import ArticleCard from "@/components/articleCard";
import Divider from "@/components/divider";
import SpotlightArticle from "@/components/spotlightArticle";
import { Article } from "@/graphql/gql/graphql";
import styles from "./template2Column.module.scss";

type Template2ColumnProps = {
  col1Article: Article;
  col2Articles: Article[];
};

const Template2Column = ({
  col1Article,
  col2Articles = [],
}: Template2ColumnProps) => {
  const {
    title,
    description,
    slug,
    subHeading,
    firstPublishedAt,
    hero,
    author,
    sport: { name: sportName, slug: sportSlug },
  } = col1Article;

  return (
    <div className={styles.container}>
      <div className={styles.spotlightArticle}>
        <SpotlightArticle
          author={author}
          fullwidthMobileImage
          image={hero?.imageUrl?.url}
          link={`/${slug}`}
          origin="home_sport_articles"
          publishedOn={firstPublishedAt}
          snippet={subHeading ?? description}
          sportName={sportName}
          sportSlug={sportSlug}
          tagType="info"
          title={title}
        />
      </div>
      <div className={styles.articlesSection}>
        {col2Articles.map((article, idx) => (
          <div key={article.id}>
            <ArticleCard
              author={article.author}
              image={article.hero?.imageUrl?.url}
              link={`/${article.slug}`}
              origin="home_sport_articles"
              publishedOn={article.firstPublishedAt}
              sportName={article.sport.name}
              sportSlug={article.sport.slug}
              title={article.title}
              displayHorizontal
            />
            {idx < col2Articles.length - 1 && <Divider color="light" />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Template2Column;
